import D2C_ProviderHosting from './Hosting'

class D2C_ProviderVultr extends D2C_ProviderHosting {
  static objectType = 'providerType'
  static active = true
  static order = 13
  static providerType = 'Vultr'
  static providerTitle = 'Vultr'
  static referal = 'If you don\'t have a Vultr account you can register with <a href="https://www.vultr.com/?ref=7772421-4F" target="_blank">this link</a> and get free credit: $50.'
  static helpLink = 'https://docs.d2c.io/providers/cloud-providers/#vultr'

  static fields = {
    ...D2C_ProviderHosting.fields,
    apiToken: {
      default: '',
      label: 'Token',
      path: 'auth.apiToken',
      required: true,
      validate(value) {
        return /^[A-Z0-9]{36}$/.test(value) ? null : 'Must contain 36 letters or numbers'
      },
      creating: {},
    },
  }
}

export default D2C_ProviderVultr
